import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit, AfterContentChecked, AfterContentInit, EventEmitter, Output, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectorRef } from '@angular/core';



import { AppDocumentos } from '../../core/models/appDocumentos.model';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../core/helper/ListFormBase';
import { AppA3DocDocument } from '../../core/models/appA3DocDocument.model';
import { AppA3DocService } from '../../core/services/appA3Doc.service';
@Component({
  selector: 'app-users-docs-dialog',
  templateUrl: './users-docs-dialog.component.html',
  styleUrls: ['./users-docs-dialog.component.scss'],
  providers: [AppA3DocService, AppA3DocDocument]
})
export class UsersDocsDialogComponent extends ListFormBase<AppA3DocDocument> implements AfterViewInit {

  panelIcon = 'event_available'; // Material icon
  panelTitle = 'Solicitud';
  panelDescription = 'Observaciones de la solicitud';
  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;
  @ViewChild('dataGrid', { static: false }) dataGrid: any;

  dataSource: any[] = [];
  availableDocs: any[] = [];
  docsSelected: string[];
  loadingA3Doc: boolean = false;


  constructor(
    protected _modelService: AppA3DocService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected appA3DocDocument: AppA3DocDocument,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<UsersDocsDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    super(_modelService, _router, _route, _messageDialog, AppA3DocDocument);
    this.isCrud = false;
    this.docsSelected = [];
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.dataSource = this.data.data;
      this.availableDocs = this.dataSource
        .filter((doc) => this.data.dataSelected.some((d) => d.id === doc.id));

      // Almacenar los ids seleccionados para el grid
      this.docsSelected = this.availableDocs.map((doc) => doc.id);

      this.cdr.detectChanges();
    });
  }

  onContentReady(event: any) {
    // Seleccionar las filas cuando el grid esté completamente listo
    if (this.dataGrid && this.dataGrid.instance) {
      this.dataGrid.instance.selectRows(this.docsSelected, false);
    }
  }

  closePopUp(change: boolean = false) {
    if (change) {
      this.dialogRef.close(this.availableDocs);
    } else {
      this.dialogRef.close(null);
    }
  }

  onSelectionChanged(event) {
    this.availableDocs = event.selectedRowsData;
  }



  onFileOpen(fileData: any) {
    const byteCharacters = atob(fileData);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  }

  onCellPrepared(e) {

    if (e.rowType === 'data' && e.column.dataField === 'name') {

      const linkElement = document.createElement('a');

      // Utiliza una función de flecha para definir el evento clic
      linkElement.onclick = () => {
        this.onFileOpen(e.data.docData);

        // Evita que el enlace realice una redirección
        return false;
      };

      // Establecer el texto del enlace
      linkElement.textContent = e.data.name;
      linkElement.style.textDecoration = 'underline';
      linkElement.style.cursor = 'pointer';

      // Limpiar el contenido existente de la celda y agregar el enlace
      e.cellElement.innerHTML = '';
      e.cellElement.appendChild(linkElement);
    }
  }


  onSubmitDocs() {
    this.closePopUp(true)
  }

}
